(() => {
  const desktop = () => matchMedia('(min-width: 990px)').matches;
  function mount(gallery) {
    if (!gallery || gallery.dataset.bwGalleryFlow) return;
    gallery.dataset.bwGalleryFlow = 'true';
    let scrollY = 0;
    const thumbnails = gallery.querySelector('[data-main-product-thumbs]');
    if (!thumbnails) return;
    thumbnails.addEventListener('pointerdown', () => { if (desktop()) scrollY = window.scrollY; }, true);
    thumbnails.addEventListener('click', () => {
      if (!desktop()) return;
      requestAnimationFrame(() => requestAnimationFrame(() => {
        const bounds = gallery.getBoundingClientRect();
        const inView = bounds.bottom > 80 && bounds.top < innerHeight - 80;
        if (inView && Math.abs(window.scrollY - scrollY) > 2) window.scrollTo({ top: scrollY, behavior: 'auto' });
      }));
    }, true);
  }
  function init() { document.querySelectorAll('product-media').forEach(mount); }
  document.addEventListener('DOMContentLoaded', init); init();
})();
